import Switch from 'flarum/common/components/Switch';

export default class Checkbox extends Switch {}
